<template>
  <div class="home">
    <Hero/>
    <VueTimeline/>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import VueTimeline from '@/components/VueTimeline.vue'

export default {
  name: 'Home',
  components: {
    Hero,
    VueTimeline
  }
}
</script>

<style lang="scss">
.home {
  background-color: #1D1E2C;
}
</style>
